export default __webpack_public_path__ + "static/media/4.1bc016d1.jpg";